// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-wrapper {
  position: relative;
}

.input_parts_orders {
  border: 1px solid gray !important;
  border-radius: 6px !important;
  position: relative !important;
  width: 100% !important;
  height: 3rem !important;
  margin: 10px !important;
  line-height: 6ex !important;
}

.required::after {
  content: " *";
  color: red;
}

label {
  position: absolute;
  top: 0.2ex;
  z-index: 1;
  left: 2em;
  background-color: white;
  padding: 0 5px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #0c3688;
}

.select-wrapper {
  position: relative;
  display: block;
}

.input::placeholder {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: #10132e;
}

select {
  border: 1px solid gray;
  border-radius: 6px;
  position: relative;
  margin: 10px;
  line-height: 6ex;
  width: 94%;
  height: 2.5rem;
}

.text_count_name_add_parts_page {
  position: absolute !important;
  left: 91% !important;
  z-index: 4 !important;
  top: 50% !important;
  font-size: 13px !important;
}

.addparts_textfieldparts {
  display: flex;
  justify-content: space-between;
  width: 96%;
  background: #ffffff;
  border-radius: 6px;
  background: #ffffff;
  border-radius: 6px;
  padding: 0.6rem;
}

.pgmlistdropdown_div {
  width: 30%;
}

@media screen and (max-width: 480px) {
  .addparts_textfieldparts {
    display: flex;
    flex-direction: column;
  }
  .pgmlistdropdown_div {
    width: 100% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/component/PartsAdd/partsaddtextfield.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AAEA;EACE,iCAAA;EACA,6BAAA;EACA,6BAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,2BAAA;AACF;;AAEA;EACE,aAAA;EACA,UAAA;AACF;;AAEA;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,kBAAA;EACA,cAAA;AACF;;AACA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAEF;;AAAA;EACE,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,cAAA;AAGF;;AADA;EACE,6BAAA;EACA,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,0BAAA;AAIF;;AAFA;EACE,aAAA;EACA,8BAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AAKF;;AAHA;EACE,UAAA;AAMF;;AAHA;EACE;IACE,aAAA;IACA,sBAAA;EAMF;EAJA;IACE,sBAAA;EAMF;AACF","sourcesContent":[".input-wrapper {\n  position: relative;\n}\n\n.input_parts_orders {\n  border: 1px solid gray !important;\n  border-radius: 6px !important;\n  position: relative !important;\n  width: 100% !important;\n  height: 3rem !important;\n  margin: 10px !important;\n  line-height: 6ex !important;\n}\n\n.required::after {\n  content: ' *';\n  color: red;\n}\n\nlabel {\n  position: absolute;\n  top: 0.2ex;\n  z-index: 1;\n  left: 2em;\n  background-color: white;\n  padding: 0 5px;\n  font-family: \"Nunito\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  color: #0c3688;\n}\n\n.select-wrapper {\n  position: relative;\n  display: block;\n}\n.input::placeholder {\n  font-family: \"Nunito\";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 16px;\n  color: #10132e;\n}\nselect {\n  border: 1px solid gray;\n  border-radius: 6px;\n  position: relative;\n  margin: 10px;\n  line-height: 6ex;\n  width: 94%;\n  height: 2.5rem;\n}\n.text_count_name_add_parts_page {\n  position: absolute !important;\n  left: 91% !important;\n  z-index: 4 !important;\n  top: 50% !important;\n  font-size: 13px !important;\n}\n.addparts_textfieldparts {\n  display: flex;\n  justify-content: space-between;\n  width: 96%;\n  background: #ffffff;\n  border-radius: 6px;\n  background: #ffffff;\n  border-radius: 6px;\n  padding: 0.6rem;\n}\n.pgmlistdropdown_div{\n  width: 30%;\n}\n\n@media screen and (max-width:480px) {\n  .addparts_textfieldparts{\n    display: flex;\n    flex-direction: column;\n  }\n  .pgmlistdropdown_div{\n    width: 100% !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
